
// Customer stories section
$('.customer-photo').off().click( function() {
  var thisPhotoIndex = $('.customer-photo').index(this); // get index of current
  // Give index attribute to parent (controls style of children)
  $(this).parent('.customer-photos').attr('data-active-index', (thisPhotoIndex+1));
  // Make current quote active
  $(this).parent('.grid-item').siblings('.grid-item').children('.customer-quote').removeClass('active').eq(thisPhotoIndex).addClass('active');
});
